import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import '../styles/VerifyStudentEmailPage.css';

const VerifyStudentEmailPage = () => {
    const [status, setStatus] = useState('verifying'); // 'verifying', 'success', 'error'
    const [message, setMessage] = useState('Verifying your email...');
    const location = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        const token = new URLSearchParams(location.search).get('token');

        if (!token) {
            setStatus('error');
            setMessage('No verification token found.');
            return;
        }

        const verifyEmail = async () => {
            try {
                const response = await axios.get(`${process.env.REACT_APP_API_URL || 'http://localhost:5001/api'}/auth/verify-student-email?token=${token}`);
                setStatus('success');
                setMessage(response.data.message);
                
                setTimeout(() => navigate('/'), 3000);
            } catch (error) {
                setStatus('error');
                setMessage(error.response?.data?.error || 'Failed to verify email. The link may be expired or invalid.');
            }
        };

        verifyEmail();
    }, [location.search, navigate]);

    return (
        <div className="verify-email-container">
            <div className="verify-email-box">
                <h2>Student Email Verification</h2>
                {status === 'verifying' && <div className="spinner"></div>}
                <p>{message}</p>
            </div>
        </div>
    );
};

export default VerifyStudentEmailPage;
